import axios from "axios";

/** En local (compose) suele ir vacío → mismo origen `/api` (nginx proxy). En Railway debe ser la URL pública del backend. */
const backendRoot = String(process.env.REACT_APP_BACKEND_URL || "")
  .trim()
  .replace(/\/$/, "");
const apiBase = backendRoot ? `${backendRoot}/api` : "/api";

const api = axios.create({
  baseURL: apiBase,
  withCredentials: true,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err.config?.url || "";
    if (err.response?.status === 401 && !url.includes("/auth/") && !window.location.pathname.includes("/login") && !window.location.pathname.startsWith("/wa/")) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (detail == null) return "Ha ocurrido un error. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail === "object" && typeof detail.mensaje === "string") return detail.mensaje;
  return String(detail);
}

export default api;
